import callApi from "./callApi";
import { resolveDateRange } from '../lib/utils';

export const fetchTestCasesByModules = async (projectId) => {
  const url = `metrics/testcases-by-module?projectId=${projectId}`;
  return await callApi(url, {}, "GET");
};
export const fetchTestCaseCoverageByModules = async (projectId) => {
  const url = `metrics/testcase-coverage-by-module?projectId=${projectId}`;
  return await callApi(url, {}, "GET");
};

export const fetchTestCasePyramidMetrics = async (projectId) => {
  const url = `metrics/testcase-pyramid-metrics?projectId=${projectId}`;
  return await callApi(url, {}, "GET");
};

export const fetchTestCaseByLoggedInUser = async (projectId, isAdmin) => {
  const url = `metrics/testcase-by-user?projectId=${projectId}&isAdmin=${isAdmin}`;
  return await callApi(url, {}, "GET");
};
export const fetchTestCycleCoverageByModules = async (projectId, queryString) => {  
  const url = `metrics/testcase-by-module-in-test-cycle?projectId=${projectId}${queryString ? `&${queryString}` : ''}`;
  return await callApi(url, {}, "GET");
};

export const fetchTestCasesNotAutomated = async (projectId, isAdmin) => {
  const url = `metrics/testcase-not-automated?projectId=${projectId}&isAdmin=${isAdmin}`;
  return await callApi(url, {}, "GET");
};

export const testcasesAssignedForExecution = async (projectId) => {
  const url = `metrics/testcase-assigned-for-execution?projectId=${projectId}`;
  const headers = {
    'X-Project-Id': projectId,
  };
  return await callApi(url, headers, "GET");
};

export const fetchDefectsLogged = async (projectId, selectedJiraProject, forceRefresh=false) => {
  const url = `metrics/defects-logged?projectId=${projectId}${selectedJiraProject ? `&jiraProject=${selectedJiraProject}` : ''}&forceRefresh=${forceRefresh}`;
  const headers = {
    'X-Project-Id': projectId,
  };
  return await callApi(url, headers, "GET");
};

export const fetchDefectsLoggedAdminOverview = async (projectIds, forceRefresh=false, isDashboard=false) => {
  const url = `jira/defects-logged-admin-overview`;
  const body = {
    projectIds,
    forceRefresh,
    isDashboard,
  }
  return await callApi(url, {}, "POST", body);
};

export const fetchTestAutomationMetrics = async ({projectIds}) => {
  const url = `metrics/test-automation-metrics`;
  const body = {
    projectIds,
  }
  return await callApi(url, {}, "POST", body);
};


export const fetchNumberOfIterationsPerTestCycle = async (projectId, queryString) => {
  const url = `metrics/iterations-per-cycle?projectId=${projectId}${queryString ? `&${queryString}` : ''}`;
  return await callApi(url, {}, "GET");
};
export const fetchTestCycleByExecutionType = async (projectId, queryString) => {
  const url = `metrics/testcycle-by-execution-type?projectId=${projectId}${queryString ? `&${queryString}` : ''}`;
  return await callApi(url, {}, "GET");
};
export const fetchAutomationProgressBySprint = async (projectId) => {
  const url = `metrics/automation-progress-by-sprint?projectId=${projectId}`;
  return await callApi(url, {}, "GET");
};
export const fetchNumberOfTestCasesBySprint = async (projectId) => {
  const url = `metrics/testcases-in-testcycles-by-sprint?projectId=${projectId}`;
  return await callApi(url, {}, "GET");
};

export const fetchNumberOfDaysForTestCycles = async (projectId) => {
  const url = `metrics/number-of-days-for-testcycle?projectId=${projectId}`;
  return await callApi(url, {}, "GET");
};
export const fetchTestCasesPassFailInTestCycle = async (projectId, queryString) => {
  const url = `metrics/test-cases-pass-fail?projectId=${projectId}${queryString ? `&${queryString}` : ''}`;
  return await callApi(url, {}, "GET");
};
export const fetchNoOfDefectsPerCycle = async (projectId, queryString, selectedJiraProject, forceRefresh=false) => {
  const url = `metrics/defects-logged-per-cycle?projectId=${projectId}${queryString ? `&${queryString}` : ''}&jiraProject=${selectedJiraProject}&forceRefresh=${forceRefresh}`;
  const headers = {
    'X-Project-Id': projectId,
  };
  return await callApi(url, headers, "GET");
};

export const fetchDefectsLoggedInJira = async (projectId, queryString, jiraProjectId, forceRefresh) => {
  const url = `metrics/defects-logged-in-jira?projectId=${projectId}${queryString ? `&${queryString}` : ''}&jiraProject=${jiraProjectId}&forceRefresh=${forceRefresh}`;
  const headers = {
    'X-Project-Id': projectId,
  };
  return await callApi(url, headers, "GET");
};

export const fetchTestCasePerAuthor = async (projectId, queryString) => {
  const url = `metrics/testcase-per-author?projectId=${projectId}${queryString ? `&${queryString}` : ''}`;
  return await callApi(url, {}, "GET");
};

export const fetchExecutionsPerUser = async (projectId, queryString) => {
  const url = `metrics/executions-per-user?projectId=${projectId}${queryString ? `&${queryString}` : ''}`;
  return await callApi(url, {}, "GET");
};

export const fetchDefectsDetectionRate = async (projectId, queryString, jiraProjectId, forceRefresh=false) => {
  const url = `metrics/defects-detection-rate?projectId=${projectId}${queryString ? `&${queryString}` : ''}&jiraProject=${jiraProjectId}&forceRefresh=${forceRefresh}`;
  const headers = {
    'X-Project-Id': projectId,
  };
  return await callApi(url, headers, "GET");
};

export const fetchIssuesLoggedInJiraForCustomType = async (projectId, queryString, jiraProjectId) => {
  const url = `metrics/custom-issues-by-status?projectId=${projectId}${queryString ? `&${queryString}` : ''}&jiraProject=${jiraProjectId}`;
  const headers = {
    'X-Project-Id': projectId,
  };
  return await callApi(url, headers, "GET");
};

export const fetchUserStoriesCovered = async (projectId, selectedJiraProject) => {
  const url = `metrics/user-stories-covered?projectId=${projectId}&jiraProject=${selectedJiraProject}`;
  const headers = {
    'X-Project-Id': projectId,
  };
  return await callApi(url, headers, "GET");
};

export const fetchSprintCompletionMetrics = async (projectId, selectedJiraProject, boardId) => {
  const url = `metrics/jira-sprint-summary?jiraProject=${selectedJiraProject}&${boardId ? `boardId=${boardId}` : ''}`;
  const headers = {
    'X-Project-Id': projectId,
  };
  return await callApi(url, headers, "GET");
};

export const fetchJiraBoards = async (projectId, selectedJiraProject, boardId) => {
  const url = `metrics/jira-project-boards?jiraProject=${selectedJiraProject}`;
  const headers = {
    'X-Project-Id': projectId,
  };
  return await callApi(url, headers, "GET");
};

export const getTestCaseSummary = (projectId, dateFilter) => {
  const { startDate, endDate, filter } = resolveDateRange(dateFilter);

  const params = new URLSearchParams();
  if (startDate) params.append('startDate', startDate);
  if (endDate) params.append('endDate', endDate);
  if (filter) params.append('filter', filter);

  const url = `dashboard/test-case-summary?${params.toString()}`;
  const headers = { 'X-Project-Id': projectId };

  return callApi(url, headers, 'GET');
};

export const getRepositoryTrend = (projectId, dateFilter) => {
  const { startDate, endDate, filter } = resolveDateRange(dateFilter);

  const params = new URLSearchParams();
  if (startDate) params.append('startDate', startDate);
  if (endDate) params.append('endDate', endDate);
  if (filter) params.append('filter', filter);

  const url = `dashboard/test-case-repo-trends?${params.toString()}`;
  const headers = { 'X-Project-Id': projectId };

  return callApi(url, headers, 'GET');
};
export const getRepositoryHealthInsights = (projectId) => {
  const url = 'dashboard/test-case-health-insights';
  const headers = { 'X-Project-Id': projectId };

  return callApi(url, headers, 'GET');
};

export const getModuleCoverageInsights = (projectId) => {
  const url = 'dashboard/test-case-module-coverage-insights';
  const headers = { 'X-Project-Id': projectId };

  return callApi(url, headers, 'GET');
};

export const getRepositoryRedundancyInsights = (projectId, dataset = 'metrics', page = 1, perPage = 10) => {
  const isPaginatedDataset = dataset === 'rarely-used' || dataset === 'frequent-manual' || dataset === 'similar';
  const paginationParams = isPaginatedDataset ? `&page=${page}&pageSize=${perPage}` : '';
  const url = `dashboard/test-case-redundancy-insights?dataset=${dataset}${paginationParams}`;
  const headers = { 'X-Project-Id': projectId };

  return callApi(url, headers, 'GET');
};

export const getDashboardAIInsights = (projectId, dateFilter, forceRefresh = false) => {
  const { startDate, endDate, filter } = resolveDateRange(dateFilter);

  const params = new URLSearchParams();
  if (startDate) params.append('startDate', startDate);
  if (endDate) params.append('endDate', endDate);
  if (filter) params.append('filter', filter);
  if (forceRefresh) params.append('forceRefresh', 'true');

  const url = `dashboard/ai-insights?${params.toString()}`;
  const headers = { 'X-Project-Id': projectId };

  return callApi(url, headers, 'GET');
};
export const getOrphanTestCycleInsights = (projectId) => {
  const url =`dashboard/orphan-test-cycle-insights`;
  const headers = { 'X-Project-Id': projectId };

  return callApi(url, headers,'GET');
};